'use strict';

blocks.register('waf-action_Background-Submit', function () {

    function bgSubmit($form, successCallback, failCallback) {
        var url = $form.find('[data-command-behavior="submit"]').eq(0).attr('href');
        var request;

        if ($form.valid()) {
            $form.addClass("loading-container");
            request = $.post(url, $form.serialize());

            request.done(function (data) {
                if (data && data.IsSuccess) {
                    onSuccess(data, $form, successCallback);
                } else {
                    onFail(data, $form, failCallback);
                }
            });

            request.fail(function (data) {
                onFail(data, $form, failCallback);
            });

            request.always(function () {
                $form.removeClass("loading-container");
            });
        }
    }

    function onFail(data, $form, callback) {
        var $content = $(data.Content);
        if ($content.length > 0) {
            blocks.compile($content);
            $form.replaceWith($content);
            /*Todo: remove this when tabs become a block*/
            ArmPQ.linkedRecords.init();
            /********************************************/
            if (typeof callback === "function") {
                callback();
            }
            $(document).scrollTop(0);
        } else {
            popup.showAlertModal("Unable to submit form", callback);
        }
    }

    function onSuccess(data, $form, callback) {
        //Deal with alerts
        var $content = $(data.Content);
        var $formAlertRow = $('.row', $form).has('.alert:not(".empty-message-container")');
        var $dataAlertRow = $('.row', $content).has('.alert:not(".empty-message-container")');
        var $formTop = $('.form-header-container', $form).eq(0);

        if ($dataAlertRow.length > 0) {
            if ($formAlertRow.lenght !== 0) {
                $formAlertRow.remove();
            }
            $formTop.after($dataAlertRow);
        }

        if (typeof callback === "function") {
            callback();
        }
    }

    /*
        1. Clone real button (create fake button)
        2. Hide real button
        3. When user clicks on fake button submit the form
        4. If form success - click on hidden real button
    */
    function intitSubmitters($form, $container) {
        $container = $container || $form;

        var $submitters = $('[data-custom-action*="Background-Submit"]', $container);

        if ($submitters.length) {
            $submitters.each(function (index, item) {
                var $item = $(item);
                var $fakeItem = $item.clone();

                $item.before($fakeItem);
                $item.hide();

                $fakeItem.off('click').on('click', function (e) {
                    e.preventDefault();
                    bgSubmit($form, function () {
                        $item.click();
                    });
                });
            });
        }
    }

    return {
        link: function link($block) {
            var $form = $block.find("form");

            intitSubmitters($form);

            $block.on('waf-action_Background-Submit:submit', function (e, options) {
                var successHandler;
                var failHandler;
                if (options) {
                    successHandler = options.onSuccess;
                    failHandler = options.onFail;
                }
                bgSubmit($form, successHandler, failHandler);

                return false;
            });

            //When loading async - initiate a content
            $("html").on("waf-linked-search-loaded widget-loaded", function (e, data) {
                intitSubmitters($form, data.$content);
            });
        }
    };
});